import type { SITE_THIRD_PARTY_SENSORS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-third-party-sensors-card/site-third-party-sensors-card.fr.ts";

export const SITE_THIRD_PARTY_SENSORS_CARD_ENGLISH_LOCALE = {
  title: "Installed third party sensors on site",
} satisfies typeof SITE_THIRD_PARTY_SENSORS_CARD_FRENCH_LOCALE;
